"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQueueNumberJson = void 0;
const ajv_1 = __importDefault(require("ajv"));
const queueNumber_schema_json_1 = __importDefault(require("./queueNumber.schema.json"));
const ajv = new ajv_1.default();
const validator = ajv.compile(queueNumber_schema_json_1.default);
function isQueueNumberJson(value) {
    const target = JSON.parse(JSON.stringify(value));
    const valid = validator(target);
    return !!valid;
}
exports.isQueueNumberJson = isQueueNumberJson;
//# sourceMappingURL=QueueNumberJson.js.map